import Cookies from 'js-cookie';

const getCookieConsent = () => JSON.parse(Cookies.get('cookie_consent') || null);

export { getCookieConsent };
